import FormDefault from "../FormDefault"
import useCardContent from "./hook"

const Content = ({
  content,
  setFormFocused,
  children,
  isActiveSortingHat,
  slug,
}) => {
  const { productFaq } = useCardContent({ content, slug })

  return (
    <FormDefault
      content={content}
      setFormFocused={setFormFocused}
      children={children}
      isActiveSortingHat={isActiveSortingHat}
      productFaq={productFaq}
    />
  )
}

export default Content
